import css from './WalletTickets.module.scss'
import React from 'react'
import MediaQuery from 'react-responsive'

import { BreakpointsMaxWidth } from 'meta/layout/breakpoints'

import { Grid, GridContainer } from 'components/Layout/Grid'

import { WalletTicketDesktopSkeleton } from './WalletTicketDesktop'
import { WalletTicketMobileSkeleton } from './WalletTicketMobile'

const WalletTicketsSkeleton: React.FC = () => {
  return (
    <>
      <MediaQuery maxWidth={BreakpointsMaxWidth.laptop}>
        {[0, 1, 2, 3, 4].map((item) => (
          <WalletTicketMobileSkeleton key={item} />
        ))}
      </MediaQuery>

      <MediaQuery minWidth={BreakpointsMaxWidth.laptop}>
        <GridContainer>
          <Grid className={css.tickets}>
            {[0, 1, 2, 3, 4].map((item) => (
              <WalletTicketDesktopSkeleton key={item} />
            ))}
          </Grid>
        </GridContainer>
      </MediaQuery>
    </>
  )
}

export default WalletTicketsSkeleton
